<template>
  <div class="tabulka FinalScreenTable" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Team ranking</div>
    </div>
    <div class="tabulka__body">
      <table>
        <thead>
          <td class="final-left">
            <SortButton
              row="rank"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Position</span>
          </td>
          <td class="final-left">
            <SortButton
              row="team.name"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Team name</span>
          </td>
          <td>
            <SortButton
              row="metric"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
            <span>Result</span>
          </td>
        </thead>
        <tr
          v-for="teamRow in sortedData"
          :key="teamRow.id"
          :class="{ table__importantRow: teamRow.team.id === myTeam.id }"
        >
          <td class="important final-left">
            <!--<div :class="{table__sipkyUp: teamRow.diff == 'up', table__sipkyDown: teamRow.diff == 'down', table__sipkyNone: teamRow.diff == 'none'}"></div>-->
            <div style="display: inline-block">
              <span :class="`table__rankColor${getRank(teamRow.rank).color}`">
                {{ teamRow.rank }}.
              </span>
              <div
                :class="`table__poharRank${getRank(teamRow.rank).rank}`"
              ></div>
            </div>
          </td>
          <td class="final-left">{{ teamRow.team.name }}</td>
          <td v-if="isMoney(teamRow.gameGoal)">
            {{ teamRow.metric | numbersThousands | inCurrency }}
          </td>
          <td v-else-if="isProducts(teamRow.gameGoal)">
            {{ teamRow.metric | numbersThousands | inPieces }}
          </td>
          <td v-else-if="isPercents(teamRow.gameGoal)">
            {{ teamRow.metric | inPercent }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani

export default {
  name: "FinalTeamRanking",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
  },
  props: {
    TableWidth: String,
  },
  data() {
    return {
      currentSortRow: "rank",
      currentSortDirection: 1,
    };
  },
  methods: {
    getRank(rank) {
      switch (rank) {
        case 1:
          return {
            color: "Gold",
            rank: "First",
          };
        case 2:
          return {
            color: "Silver",
            rank: "Second",
          };
        case 3:
          return {
            color: "Bronze",
            rank: "Third",
          };
        case 4:
          return {
            color: "Potato",
            rank: "Fourth",
          };
        default:
          return {
            color: "Gray",
            rank: "None",
          };
      }
    },
    isMoney(goal) {
      if (goal == "MONEY" || goal == "EARNED" || goal == "PROFIT") {
        return true;
      }
      return false;
    },
    isProducts(goal) {
      if (goal == "PRODUCTS_SOLD" || goal == "POPULAR_PRODUCT") {
        return true;
      }
      return false;
    },
    isPercents(goal) {
      if (goal == "MARKET_SHARE") {
        return true;
      }
      return false;
    },
  },
  computed: {
    ...mapGetters({
      sourceData: "gameResult",
      myTeam: "myTeam",
    }),
  },
};
</script>
